export default __webpack_public_path__ + "static/media/3.20aec485.png";